import { render, staticRenderFns } from "./FnrhInfoModal.vue?vue&type=template&id=2f945a30&scoped=true&"
import script from "./FnrhInfoModal.vue?vue&type=script&lang=js&"
export * from "./FnrhInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./FnrhInfoModal.vue?vue&type=style&index=0&id=2f945a30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f945a30",
  null
  
)

export default component.exports